import React, { Dispatch, useContext } from 'react';
import { Row, Col } from 'antd';
import styled from 'styled-components';

import TicketItem from '../TicketItem';
import { OrderContext } from '../..';

interface TicketListByParkProps {
  title: string;
  tickets: any[];
  setDisableCreateOrder: Dispatch<React.SetStateAction<boolean>>;
  disableCreateOrder: boolean;
  hasChangeProperty: React.MutableRefObject<boolean>;
  isChangingNumberRef: React.MutableRefObject<boolean>;
}

const TicketListByPark = (props: TicketListByParkProps) => {
  const {
    title,
    tickets,
    disableCreateOrder,
    setDisableCreateOrder,
    hasChangeProperty,
    isChangingNumberRef,
  } = props;

  const {
    orderDetailData,
    onRemoveTicket,
    setIsLoading,
    onSetTicket,
    ticketsMergedNeedUpdateAmount,
    setEnablePaymentAction,
    isSubmitted,
    originOrderDetailData,
    ticketsGettingPrice,
    setTicketsGettingPrice,
    bpAllocatedDebt,
  } = useContext(OrderContext);

  return (
    <TicketContainer>
      <Row>
        <TitleBlock>
          <StyledH4>{title}</StyledH4>
        </TitleBlock>
      </Row>
      <TicketBlock>
        {tickets.map((ticket, idx) => {
          return (
            <SticketContainer
              borderBottom={idx === tickets.length - 1}
              key={ticket?.key}
            >
              <TicketItem
                {...ticket}
                totalTicketInOrder={orderDetailData?.items.length ?? 0}
                onRemoveTicket={onRemoveTicket}
                setLoadingPage={setIsLoading}
                onSetTicket={onSetTicket}
                ticketsMergedNeedUpdateAmount={ticketsMergedNeedUpdateAmount}
                setEnablePaymentAction={setEnablePaymentAction}
                isSubmitted={isSubmitted}
                originOrderDetailData={originOrderDetailData}
                ticketsGettingPrice={ticketsGettingPrice}
                setTicketsGettingPrice={setTicketsGettingPrice}
                bpAllocatedDebt={bpAllocatedDebt}
                disableCreateOrder={disableCreateOrder}
                setDisableCreateOrder={setDisableCreateOrder}
                hasChangeProperty={hasChangeProperty}
                isChangingNumberRef={isChangingNumberRef}
              />
            </SticketContainer>
          );
        })}
      </TicketBlock>
    </TicketContainer>
  );
};

export default TicketListByPark;

const TicketContainer = styled.div``;

const TicketBlock = styled.div`
  margin-top: 24px;
`;

const TitleBlock = styled(Col)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const StyledH4 = styled.h4`
  font-weight: 600;
  font-size: 18px;
  margin: 0;
`;

const SticketContainer = styled.div<{ borderBottom: boolean }>`
  border-top: dashed 2px #d9d9d9;
  border-bottom: ${props =>
    props.borderBottom ? 'dashed 2px #D9D9D9' : 'none'};
`;
